// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {
   cursor: pointer;
   margin-left: 30px;
   color: #00bed6;
}

::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}

::ng-deep .mat-button-focus-overlay {
   background-color: transparent !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/view-flow/view-flow.component.css"],"names":[],"mappings":"AAAA;GACG,eAAe;GACf,iBAAiB;GACjB,cAAc;AACjB;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;GACG,wCAAwC;AAC3C","sourcesContent":["a {\n   cursor: pointer;\n   margin-left: 30px;\n   color: #00bed6;\n}\n\n::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n\n::ng-deep .mat-button-focus-overlay {\n   background-color: transparent !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
